module.exports = __webpack_public_path__ + "img/slash-dark.5817f19d.svg";